import React from 'react'
import PropTypes from 'prop-types'
import Immutable from 'immutable'
import ImmutablePropTypes from 'react-immutable-proptypes'
import moment from 'moment'

import { renderTextField } from '../utils'
import FormHoc from '../../../hocs/FormHoc'
import Button from '../../button'
import ScrollableList from '../../list/ScrollableList'
import { getCopaidSessionsByDate } from '../../../utils/copaySessions'
import '../styles.scss'
import '../../dialog/TreatmentDialog/TreatmentDialog.scss'
import './copaid.scss'
import { CopaidSessionsBalanceChip } from '../../chips'

const CopaidSessionsSection = ({
  patient,
  fields,
  handleChange,
  onAddSession,
  onDeleteSession,
  hideHeader,
}) => {
  const balance = patient.get('copaidSessionsBalance', 0)

  const handleAmountChange = (event) => {
    let { value } = event.target
    if (value === '') {
      handleChange(event)
      return
    }
    value = value.replace(/\D/g, '').replace(/^0+/, '')
    handleChange({ target: { name: 'newCopaidAmount', value } })
  }

  const handleSubmit = (event) => {
    event.preventDefault()
    const amount = parseInt(fields.newCopaidAmount, 10)
    if (!Number.isInteger(amount) || amount <= 0) {
      alert('Ingrese una cantidad válida de sesiones')
      return
    }
    const date = fields.newCopaidDate || moment().format('YYYY-MM-DD')
    onAddSession({ amount, date })
    handleChange({ target: { name: 'newCopaidAmount', value: '' } })
  }

  const sessions = patient.get('copaidSessions', Immutable.List())

  return (
    <div className='copaid-container'>
      {!hideHeader && (
        <div className='dialog-title'>
          <h3>Copagos</h3>
          <CopaidSessionsBalanceChip balance={balance} />
        </div>
      )}
      <div className='dialog-content'>
        <form onSubmit={handleSubmit}>
          <div className='form-row form-row--center'>
            {renderTextField({
              label: 'Fecha',
              name: 'newCopaidDate',
              type: 'date',
              value: fields.newCopaidDate,
              onChange: handleChange,
              className: 'copaid-date-field',
            })}
            {renderTextField({
              label: 'Cantidad',
              name: 'newCopaidAmount',
              type: 'number',
              value: fields.newCopaidAmount,
              onChange: handleAmountChange,
              inputProps: { min: 1, step: 1 },
              className: 'copaid-amount-field',
            })}
            <Button type='submit'>Registrar copago</Button>
          </div>
        </form>
        <div className='copaid-history'>
          <small>Historial de Copagos</small>
          <ScrollableList
            items={getCopaidSessionsByDate(sessions)}
            onDelete={onDeleteSession}
            noRowsMessage='No se han registrado copagos para este paciente.'
          />
        </div>
      </div>
    </div>
  )
}

CopaidSessionsSection.propTypes = {
  patient: ImmutablePropTypes.map.isRequired,
  fields: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  onAddSession: PropTypes.func.isRequired,
  onDeleteSession: PropTypes.func.isRequired,
  hideHeader: PropTypes.bool,
}

const CopaidSessionsSectionForm = FormHoc(CopaidSessionsSection)

const CopaidSessionsSectionContainer = (props) => (
  <div className='dialog-section'>
    <CopaidSessionsSectionForm
      {...props}
      defaultFields={{
        newCopaidDate: moment().format('YYYY-MM-DD'),
        newCopaidAmount: '',
      }}
    />
  </div>
)

export default CopaidSessionsSectionContainer
